// Colourful illustrated tile per game — flat shapes in the brand fills, chunky
// ink outlines. 48x48 viewBox, transparent background (the card supplies a pale
// tint via gameTint — see theme.ts TINT).

const S = (inner: string) =>
  `<svg class="gicon" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" ` +
  `stroke="#1B1534" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;

const ICONS: Record<string, string> = {
  boxing: S(
    `<path d="M14 20a7 7 0 0 1 7-7h6a8 8 0 0 1 8 8v5a6 6 0 0 1-6 6H16a3 3 0 0 1-3-3z" fill="#FF6B5B"/>` +
    `<path d="M14 21h-3a4 4 0 0 0-4 4 4 4 0 0 0 4 4h3" fill="#E5484D"/>` +
    `<path d="M16 32v3a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-3" fill="#FFC53D"/>`,
  ),
  chess: S(
    `<path d="M16 40h16" fill="none"/>` +
    `<path d="M18 40l1-9h10l1 9z" fill="#FFFFFF"/>` +
    `<path d="M17 31h14l-1-4H18z" fill="#E1D4FF"/>` +
    `<path d="M20 27c-3-3-3-8 0-10-2-1-2-4 1-4 1-2 5-2 6 0 3 0 3 3 1 4 3 2 3 7 0 10z" fill="#FFFFFF"/>` +
    `<circle cx="24" cy="12" r="3" fill="#FFFFFF"/>`,
  ),
  checkers: S(
    `<rect x="8" y="8" width="32" height="32" rx="3" fill="#FFE7A8"/>` +
    `<path d="M8 16h32M8 24h32M8 32h32M16 8v32M24 8v32M32 8v32" stroke="#1B1534" stroke-width="1.4"/>` +
    `<circle cx="18" cy="30" r="5" fill="#FF6B5B"/>` +
    `<circle cx="30" cy="18" r="5" fill="#1B1534"/>`,
  ),
  snl: S(
    `<rect x="8" y="8" width="32" height="32" rx="3" fill="#BDF3E3"/>` +
    `<path d="M14 40l2-14 4 2 2-12" fill="none" stroke="#FFC53D" stroke-width="3"/>` +
    `<path d="M15 36l4 1M16 30l4 1M17 24l4 1" stroke="#FFC53D" stroke-width="1.8"/>` +
    `<path d="M32 12c-6 2-4 9 1 8s4 8-3 9" fill="none" stroke="#2ED3A6" stroke-width="4"/>` +
    `<circle cx="32" cy="12" r="3" fill="#2ED3A6"/><circle cx="31" cy="11" r="1" fill="#fff"/>`,
  ),
  wordduel: S(
    `<rect x="6" y="18" width="11" height="12" rx="2" fill="#37D67A"/>` +
    `<rect x="18.5" y="18" width="11" height="12" rx="2" fill="#FFC53D"/>` +
    `<rect x="31" y="18" width="11" height="12" rx="2" fill="#8E86AE"/>` +
    `<path d="M9 24l2 2 3-4M22 24l2 2 3-4" stroke="#1B1534" fill="none"/>`,
  ),
  shred: S(
    `<circle cx="13" cy="14" r="4" fill="#FF6B5B"/><circle cx="13" cy="30" r="4" fill="#FF6B5B"/>` +
    `<path d="M16 16l18 16M16 28l18-16" stroke="#FFFFFF" stroke-width="3"/>` +
    `<path d="M30 24h8" stroke="#FFFFFF"/>` +
    `<path d="M34 24l4-3v6z" fill="#FFC53D"/>`,
  ),
  asteroids: S(
    `<path d="M24 12l7 20-7-4-7 4z" fill="#FFFFFF"/>` +
    `<path d="M13 30l-2 4M35 30l2 4" stroke="#FFC53D" stroke-width="3"/>` +
    `<path d="M32 12l4-1 2 3-2 4-4 1-2-4z" fill="#8B5CF6"/>` +
    `<circle cx="12" cy="16" r="3" fill="#8B5CF6"/>`,
  ),
  invaders: S(
    `<path d="M15 14h4v3h10v-3h4v3h3v6h3v8h-3v-3h-3v4H15v-4h-3v3H9v-8h3v-6h3z" fill="#37D67A"/>` +
    `<rect x="18" y="21" width="3" height="3" fill="#1B1534"/><rect x="27" y="21" width="3" height="3" fill="#1B1534"/>` +
    `<path d="M17 34l-2 4M31 34l2 4" stroke="#37D67A" stroke-width="2.4"/>`,
  ),
  bubble: S(
    `<circle cx="17" cy="15" r="7" fill="#FF6B5B"/>` +
    `<circle cx="31" cy="19" r="6" fill="#4D7CFF"/>` +
    `<circle cx="20" cy="29" r="6" fill="#37D67A"/>` +
    `<circle cx="32" cy="33" r="5" fill="#FFC53D"/>` +
    `<circle cx="15" cy="12" r="1.6" fill="#fff" stroke="none"/>`,
  ),
  tetris: S(
    `<rect x="9" y="9" width="8" height="8" fill="#4D7CFF"/><rect x="17" y="9" width="8" height="8" fill="#4D7CFF"/>` +
    `<rect x="25" y="9" width="8" height="8" fill="#4D7CFF"/><rect x="25" y="17" width="8" height="8" fill="#4D7CFF"/>` +
    `<rect x="17" y="25" width="8" height="8" fill="#FFC53D"/><rect x="25" y="25" width="8" height="8" fill="#FFC53D"/>` +
    `<rect x="17" y="33" width="8" height="8" fill="#8B5CF6"/><rect x="9" y="33" width="8" height="8" fill="#8B5CF6"/>`,
  ),
  snake: S(
    `<path d="M10 12h14a5 5 0 0 1 0 10H15a5 5 0 0 0 0 10h18" fill="none" stroke="#2ED3A6" stroke-width="6"/>` +
    `<circle cx="33" cy="32" r="4" fill="#2ED3A6"/><circle cx="34" cy="31" r="1.3" fill="#fff"/>` +
    `<rect x="20" y="24" width="6" height="6" rx="1.5" fill="#FF6B5B"/>`,
  ),
  hormuz: S(
    `<path d="M6 30h28l-4 8H10z" fill="#4D7CFF"/>` +
    `<path d="M14 30V20h9l5 5v5z" fill="#FFFFFF"/>` +
    `<path d="M34 8l1.6 4.8L40 14l-4.4 1.2L34 20l-1.6-4.8L28 14l4.4-1.2z" fill="#FFC53D"/>` +
    `<path d="M8 40q4-3 8 0t8 0 8 0" fill="none" stroke="#1B1534"/>`,
  ),
  worms: S(
    `<path d="M6 40q6-14 14 0" fill="none" stroke="#C98B3C" stroke-width="5"/>` +
    `<circle cx="13" cy="26" r="5" fill="#2ED3A6"/>` +
    `<path d="M9 22a4 4 0 0 1 8 0z" fill="#FFC53D"/>` +
    `<path d="M16 20l14-12" stroke="#FFFFFF" stroke-width="3"/>` +
    `<circle cx="31" cy="8" r="3.6" fill="#FF6B5B"/>` +
    `<path d="M30 42q6-14 12 0" fill="none" stroke="#C98B3C" stroke-width="5"/>`,
  ),
  tug: S(
    `<path d="M6 24q9 5 18 0t18 0" fill="none" stroke="#C98B3C" stroke-width="4"/>` +
    `<rect x="21.5" y="14" width="5" height="5" rx="1" fill="#FF6B5B" stroke="none"/>` +
    `<path d="M22 19v3" stroke="#1B1534" stroke-width="1.6"/>` +
    `<circle cx="11" cy="24" r="5" fill="#37D67A"/>` +
    `<path d="M6 30l4-5" stroke="#1B1534" stroke-width="3"/>` +
    `<circle cx="37" cy="24" r="5" fill="#FF6B5B"/>` +
    `<path d="M42 30l-4-5" stroke="#1B1534" stroke-width="3"/>`,
  ),
  wordbattle: S(
    `<rect x="8" y="8" width="14" height="14" rx="2.5" fill="#37D67A"/>` +
    `<rect x="26" y="8" width="14" height="14" rx="2.5" fill="#FFC53D"/>` +
    `<rect x="8" y="26" width="14" height="14" rx="2.5" fill="#4D7CFF"/>` +
    `<rect x="26" y="26" width="14" height="14" rx="2.5" fill="#FF6CC4"/>` +
    `<path d="M15 15l18 18" fill="none" stroke="#1B1534" stroke-width="3.4"/>` +
    `<circle cx="15" cy="15" r="2.6" fill="#1B1534" stroke="none"/>` +
    `<circle cx="33" cy="33" r="3.4" fill="#1B1534" stroke="none"/>`,
  ),
};

const TINTS: Record<string, string> = {
  boxing: "#FFD3CC",
  chess: "#E1D4FF",
  checkers: "#FFD3CC",
  snl: "#BDF3E3",
  wordduel: "#FFD3CC",
  shred: "#FFD1EC",
  asteroids: "#CFDBFF",
  invaders: "#BDF3E3",
  bubble: "#CFDBFF",
  tetris: "#E1D4FF",
  snake: "#FFE7A8",
  hormuz: "#CFDBFF",
  worms: "#FFE7A8",
  tug: "#FFD3CC",
  wordbattle: "#FFD1EC",
};

export function gameIcon(id: string): string {
  return ICONS[id] ?? S(`<circle cx="24" cy="24" r="14" fill="#8B5CF6"/>`);
}

export function gameTint(id: string): string {
  return TINTS[id] ?? "#E1D4FF";
}
